import ContractDetail from './ContractDetail';
import ContractList from './ContractList';

const routes = [
  {
    path: '',
    element: <ContractList />,
  },
  {
    path: ':address',
    element: <ContractDetail />,
  },
];

export default routes;
export { ContractDetail, ContractList };
